import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import BlurBoxBackgroundContainer from "../../component/BlurBoxBackgroundContainer";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "-210px",
    marginBottom: "40px",
    paddingLeft: "40px",
    paddingRight: "40px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-120px",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
    height: "100%",
  },
  transparentBox: {
    width: "100%",
    height: "auto",
    border: "1px solid rgb(233,237,244)",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    padding: "30px 310px",
    [theme.breakpoints.down("s")]: {
      padding: "30px 10px",
    },
    [theme.breakpoints.between("s", "s")]: {
      padding: "30px 40px",
    },
    [theme.breakpoints.between("lm", "lm")]: {
      padding: "30px 200px",
    },
    [theme.breakpoints.between("md", "md")]: {
      padding: "30px 100px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      padding: "30px 80px",
    },
  },
  title: {
    paddingBottom: "30px",
  },
  topPararaph: {
    color: theme.palette.primary.main,
    marginBottom: "30px",
    fontWeight: 600,
  },
  policyTitle: {
    fontSize: "16px",
    color: theme.palette.primary.main,
    fontWeight: 700,
    marginBottom: "5px",
  },
  subPolicyTitle: {
    fontSize: "15px",
  },
  sectionPolicy: {
    marginBottom: "5px",
  },
}));
export default function PolicyPage() {
  const classes = useStyles();
  return (
    <BlurBoxBackgroundContainer background="policyPage--background">
      <Container maxWidth="lg" className={classes.container}>
        <Typography variant="h1" color="primary" className={classes.title}>
          サイトポリシー
        </Typography>
        <Box className={classes.transparentBox}>
          <Typography variant="body1" className={classes.topPararaph}>
            当社では、個人情報保護法及びその他の関連法令、各ガイドラインの遵守並びに社内ルールを整備し、
            当社が業務の遂行にあたって、お客様から提供・貸与していただく各種の情報の適切な管理・運用いたします。
          </Typography>
          <ol>
            <Box className={classes.sectionPolicy}>
              <SubTitle>個人情報の定義</SubTitle>
              <Typography variant="body1">
                個人情報とは、個人に関する情報であり、当該情報に含まれる氏名、住所、職務経歴を
                はじめ電話番号、メールアドレスなどの番号や記号、その他の符号により当該個人と識
                別でき るものをいいます。
              </Typography>
              <Typography variant="body1">
                また、組み合わせることによって個人が識別できてしまうものも個人情報といたします。
              </Typography>
            </Box>
            <Box className={classes.sectionPolicy}>
              <SubTitle>個人情報利用目的の範囲</SubTitle>
              <Typography variant="body1">
                お客様が当社のサービスを利用される際に提供された個人情報を取り扱うにあたって、
                その利用の目的を出来る限り特定いたします。
              </Typography>
              <Typography variant="body1">
                当社のプライバシーの考え方は、当社が直接管理していない人や会社などには適用されません。
              </Typography>
            </Box>
            <Box className={classes.sectionPolicy}>
              <SubTitle>情報の収集と利用</SubTitle>
              <Typography variant="body1">
                当社は個人情報保護を適切に行うべく、当社の事業目的を達成する範囲内(最適な就業
                先紹介・各種サービスの提供)でのみ個人情報の収集･利用を行います。
              </Typography>
              <Typography variant="body1">
                個人情報の収集・利用・提供は、事前にお客様が同意の上、事業目的を達成する範囲内
                でのみ行うものとし、その取扱いには万全の管理体制を施します。
              </Typography>
              <Typography variant="body1">
                また、お客様の同意を得ず、第三者に開示・提供することはありません。
              </Typography>
              <ol>
                <li className={classes.subPolicyTitle}>法令に基づく場合</li>
                <li className={classes.subPolicyTitle}>
                  国、地方自治体、裁判所、
                  警察その他法律や条例などで定められた権限を持つ機関
                  より要請があった場合
                </li>
              </ol>
            </Box>
            <Box className={classes.sectionPolicy}>
              <SubTitle>委託先の監督</SubTitle>
              <Typography variant="body1">
                当社は、事業目的を達成するにあたり、個人情報を外部へ委託する場合がございます。
              </Typography>{" "}
              <Typography variant="body1">
                そのような場合は個人情報保護水準が高いことを条件として委託先を選定し、秘密保持
                契約を締結した上で、必要かつ適切な監督を行います。
              </Typography>
            </Box>
            <Box className={classes.sectionPolicy}>
              <SubTitle>個人情報の訂正</SubTitle>{" "}
              <Typography variant="body1">
                当社は、お客様から自己の個人情報の開示、訂正、変更、削除を求められた場合は、ご
                本人であることを確認後、遅滞なく登録情報を開示、訂正、変更、削除いたします。
              </Typography>{" "}
              <Typography variant="body1">
                ただし、そのことにより次のいずれかに該当する場合は、その全部又は一部を開示、訂
                正、変更、削除しないこともあり、その場合には、その旨を遅滞なく通知いたします。
              </Typography>
              <ol>
                <li className={classes.subPolicyTitle}>
                  当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
                </li>
                <li className={classes.subPolicyTitle}>
                  法令に違反することとなる場合
                </li>
              </ol>
            </Box>
          </ol>
        </Box>
      </Container>
    </BlurBoxBackgroundContainer>
  );
}

const SubTitle = ({ children }) => {
  const classes = useStyles();
  return <li className={classes.policyTitle}>{children}</li>;
};
